// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  text-decoration: none !important;
}

@media (max-width: 767px) {
  li.header-nav {
    font-size: 16px !important;
    margin: 0px 0px 0px 8px !important;
}
  .download-postman-btn {
    padding: 8px 6px !important;
    font-size: 12px !important;
  }
}
@media (max-width: 544px) {
li.header-nav {
  font-size: 12px !important;
  margin: 0px 0px 0px 8px !important;
}
.download-postman-btn {
  padding: 8px 4px !important;
  font-size: 9px !important;
  font-weight: 700 !important;
}
}
@media (max-width: 467px) {
  li.header-nav {
    font-size: 13px !important;
    margin: 0px 0px 0px 9px !important;
  }
  .download-postman-btn {
    padding: 8px 6px !important;
    font-size: 10px !important;
  }
}

@media (max-width: 411px) {
  img.logo-header {
    width: 129px !important;
  }
}
@media (max-width: 390px) {
  .download-postman-btn {
    padding: 8px 3px !important;
    font-size: 8px !important;
    font-weight: 800 !important;
  }
}

.header-bottam {
  padding: 0px 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  z-index: 1024;
  width: 100%;
  background: #fff;
  top: 0px;
  height: 99px;
  box-shadow: rgba(112, 144, 176, 0.18) 14px 17px 120px 4px;
}
.header-img-logo {
  width: 14%;
}
.header-img-logo img {
  width: 100%;
}
ul.navigate-n {
  text-align: center;
  display: flex;
  padding-left: 0px;
  align-items: center;
  margin-bottom: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/header.css"],"names":[],"mappings":"AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,0BAA0B;IAC1B,kCAAkC;AACtC;EACE;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF;AACA;AACA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;AACA;EACE;IACE,0BAA0B;IAC1B,kCAAkC;EACpC;EACA;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;EAC7B;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,QAAQ;EAER,YAAY;EACZ,yDAAyD;AAC3D;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600&display=swap\");\n\na {\n  text-decoration: none !important;\n}\n\n@media (max-width: 767px) {\n  li.header-nav {\n    font-size: 16px !important;\n    margin: 0px 0px 0px 8px !important;\n}\n  .download-postman-btn {\n    padding: 8px 6px !important;\n    font-size: 12px !important;\n  }\n}\n@media (max-width: 544px) {\nli.header-nav {\n  font-size: 12px !important;\n  margin: 0px 0px 0px 8px !important;\n}\n.download-postman-btn {\n  padding: 8px 4px !important;\n  font-size: 9px !important;\n  font-weight: 700 !important;\n}\n}\n@media (max-width: 467px) {\n  li.header-nav {\n    font-size: 13px !important;\n    margin: 0px 0px 0px 9px !important;\n  }\n  .download-postman-btn {\n    padding: 8px 6px !important;\n    font-size: 10px !important;\n  }\n}\n\n@media (max-width: 411px) {\n  img.logo-header {\n    width: 129px !important;\n  }\n}\n@media (max-width: 390px) {\n  .download-postman-btn {\n    padding: 8px 3px !important;\n    font-size: 8px !important;\n    font-weight: 800 !important;\n  }\n}\n\n.header-bottam {\n  padding: 0px 60px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: fixed;\n  z-index: 1024;\n  width: 100%;\n  background: #fff;\n  top: 0px;\n  height: 90px;\n  height: 99px;\n  box-shadow: rgba(112, 144, 176, 0.18) 14px 17px 120px 4px;\n}\n.header-img-logo {\n  width: 14%;\n}\n.header-img-logo img {\n  width: 100%;\n}\nul.navigate-n {\n  text-align: center;\n  display: flex;\n  padding-left: 0px;\n  align-items: center;\n  margin-bottom: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
